export default [
  {
    name: "North Vanc Zone 1",
    crane: 265.0,
    dump: 131.0,
    split: 138.0,
    bounds: [
      {
        lng: -123.0061035,
        lat: 49.3574164
      },
      {
        lng: -123.0199242,
        lat: 49.3357498
      },
      {
        lng: -123.0305677,
        lat: 49.3196952
      },
      {
        lng: -123.0333995,
        lat: 49.3130092
      },
      {
        lng: -123.0409097,
        lat: 49.3194436
      },
      {
        lng: -123.0509948,
        lat: 49.3158349
      },
      {
        lng: -123.0656719,
        lat: 49.3136527
      },
      {
        lng: -123.079491,
        lat: 49.3191632
      },
      {
        lng: -123.0903911,
        lat: 49.3198073
      },
      {
        lng: -123.0897044,
        lat: 49.3131491
      },
      {
        lng: -123.0767422,
        lat: 49.3053436
      },
      {
        lng: -123.0569171,
        lat: 49.3026844
      },
      {
        lng: -123.0366596,
        lat: 49.2969771
      },
      {
        lng: -123.0157185,
        lat: 49.2955201
      },
      {
        lng: -122.9896259,
        lat: 49.3051469
      },
      {
        lng: -122.9894543,
        lat: 49.3296531
      },
      {
        lng: -122.9690266,
        lat: 49.3287581
      },
      {
        lng: -122.936411,
        lat: 49.3340159
      },
      {
        lng: -122.9154664,
        lat: 49.3443049
      },
      {
        lng: -123.0061035,
        lat: 49.3574164
      }
    ]
  },
  {
    name: "Tri City Zone 1",
    crane: 135.0,
    dump: 81.0,
    split: 87.0,
    bounds: [
      {
        lng: -122.8928037,
        lat: 49.2548404
      },
      {
        lng: -122.892649,
        lat: 49.2491715
      },
      {
        lng: -122.8925648,
        lat: 49.2491713
      },
      {
        lng: -122.8928037,
        lat: 49.2548404
      }
    ]
  },
  {
    name: "Tri City Zone 1",
    crane: 135.0,
    dump: 81.0,
    split: 87.0,
    bonds: [
      {
        lng: -122.8931419,
        lat: 49.2672307
      },
      {
        lng: -122.8928742,
        lat: 49.2565135
      },
      {
        lng: -122.8928037,
        lat: 49.2548404
      },
      {
        lng: -122.8931419,
        lat: 49.2672307
      }
    ]
  },
  {
    name: "Tri City Zone 1",
    crane: 135.0,
    dump: 81.0,
    split: 87.0,
    bounds: [
      {
        lng: -122.8925648,
        lat: 49.2491713
      },
      {
        lng: -122.8920594,
        lat: 49.2371739
      },
      {
        lng: -122.8915446,
        lat: 49.2190412
      },
      {
        lng: -122.87352,
        lat: 49.2251234
      },
      {
        lng: -122.8145545,
        lat: 49.2199662
      },
      {
        lng: -122.8117395,
        lat: 49.2168394
      },
      {
        lng: -122.8127044,
        lat: 49.2041369
      },
      {
        lng: -122.8125961,
        lat: 49.1914343
      },
      {
        lng: -122.7777056,
        lat: 49.1914718
      },
      {
        lng: -122.7565642,
        lat: 49.1869013
      },
      {
        lng: -122.7349121,
        lat: 49.1814293
      },
      {
        lng: -122.7348822,
        lat: 49.1900912
      },
      {
        lng: -122.7253396,
        lat: 49.1898318
      },
      {
        lng: -122.7275385,
        lat: 49.2069106
      },
      {
        lng: -122.7409633,
        lat: 49.2132077
      },
      {
        lng: -122.7688497,
        lat: 49.2141354
      },
      {
        lng: -122.7626923,
        lat: 49.236218
      },
      {
        lng: -122.7625739,
        lat: 49.2424534
      },
      {
        lng: -122.7625411,
        lat: 49.2494173
      },
      {
        lng: -122.7889985,
        lat: 49.2493613
      },
      {
        lng: -122.8157132,
        lat: 49.2491512
      },
      {
        lng: -122.8251116,
        lat: 49.2491033
      },
      {
        lng: -122.8345101,
        lat: 49.2490967
      },
      {
        lng: -122.853264,
        lat: 49.2491092
      },
      {
        lng: -122.8629653,
        lat: 49.249028
      },
      {
        lng: -122.8728169,
        lat: 49.249114
      },
      {
        lng: -122.8925648,
        lat: 49.2491713
      }
    ]
  },
  {
    name: "Burnaby Zone 1",
    crane: 215.0,
    dump: 124.0,
    split: 131.0,
    bounds: [
      {
        lng: -122.8933133,
        lat: 49.2671185
      },
      {
        lng: -122.8933563,
        lat: 49.2696668
      },
      {
        lng: -122.8935392,
        lat: 49.2721718
      },
      {
        lng: -122.8935819,
        lat: 49.2760633
      },
      {
        lng: -122.8941831,
        lat: 49.2822514
      },
      {
        lng: -122.8951475,
        lat: 49.2930635
      },
      {
        lng: -122.9699279,
        lat: 49.2928333
      },
      {
        lng: -122.9699709,
        lat: 49.2803205
      },
      {
        lng: -123.0229711,
        lat: 49.2809085
      },
      {
        lng: -123.0230999,
        lat: 49.2325359
      },
      {
        lng: -122.9606581,
        lat: 49.2215776
      },
      {
        lng: -122.9622031,
        lat: 49.2566581
      },
      {
        lng: -122.9112197,
        lat: 49.2590108
      },
      {
        lng: -122.8933133,
        lat: 49.2671185
      }
    ]
  },
  {
    name: "New Westminster Zone 2",
    crane: 215.0,
    dump: 124.0,
    split: 131.0,
    bounds: [
      {
        lng: -123.0231005,
        lat: 49.2325081
      },
      {
        lng: -123.0231005,
        lat: 49.1997657
      },
      {
        lng: -122.9774812,
        lat: 49.1785894
      },
      {
        lng: -122.9761079,
        lat: 49.1563656
      },
      {
        lng: -122.9426764,
        lat: 49.1583586
      },
      {
        lng: -122.9259824,
        lat: 49.1707337
      },
      {
        lng: -122.9122494,
        lat: 49.1931755
      },
      {
        lng: -122.9458953,
        lat: 49.2196436
      },
      {
        lng: -123.0231005,
        lat: 49.2325081
      }
    ]
  },
  {
    name: "New Westminster Zone 1",
    crane: 199.0,
    dump: 109.0,
    split: 116.0,
    bounds: [
      {
        lng: -122.9621605,
        lat: 49.2565882
      },
      {
        lng: -122.9606154,
        lat: 49.2215076
      },
      {
        lng: -122.9458527,
        lat: 49.2196016
      },
      {
        lng: -122.9163268,
        lat: 49.1967233
      },
      {
        lng: -122.9039673,
        lat: 49.20121
      },
      {
        lng: -122.8950408,
        lat: 49.2081638
      },
      {
        lng: -122.89163,
        lat: 49.219181
      },
      {
        lng: -122.8924659,
        lat: 49.2443745
      },
      {
        lng: -122.8933133,
        lat: 49.2671185
      },
      {
        lng: -122.9111135,
        lat: 49.259025
      },
      {
        lng: -122.9621605,
        lat: 49.2565882
      }
    ]
  },
  {
    name: "Vancouver Zone 1",
    crane: 250.0,
    dump: 131.0,
    split: 139.0,
    bounds: [
      {
        lng: -122.9701859,
        lat: 49.2925532
      },
      {
        lng: -123.0392791,
        lat: 49.295296
      },
      {
        lng: -123.0770444,
        lat: 49.292693
      },
      {
        lng: -123.0773019,
        lat: 49.2582965
      },
      {
        lng: -123.075714,
        lat: 49.2572812
      },
      {
        lng: -123.0759072,
        lat: 49.248538
      },
      {
        lng: -123.0767762,
        lat: 49.2327618
      },
      {
        lng: -123.0772161,
        lat: 49.2026822
      },
      {
        lng: -123.048892,
        lat: 49.2038599
      },
      {
        lng: -123.0235722,
        lat: 49.200467
      },
      {
        lng: -123.0232288,
        lat: 49.2806284
      },
      {
        lng: -122.9702289,
        lat: 49.2800404
      },
      {
        lng: -122.9701859,
        lat: 49.2925532
      }
    ]
  },
  {
    name: "Vancouver Zone 3",
    crane: 325.0,
    dump: 191.0,
    split: 197.0,
    bounds: [
      {
        lng: -123.1294227,
        lat: 49.2687076
      },
      {
        lng: -123.1232858,
        lat: 49.2692399
      },
      {
        lng: -123.1159043,
        lat: 49.2719279
      },
      {
        lng: -123.1107974,
        lat: 49.2729639
      },
      {
        lng: -123.1004548,
        lat: 49.2730339
      },
      {
        lng: -123.0998111,
        lat: 49.2907129
      },
      {
        lng: -123.1399798,
        lat: 49.3160656
      },
      {
        lng: -123.1623817,
        lat: 49.3114214
      },
      {
        lng: -123.1605783,
        lat: 49.2962235
      },
      {
        lng: -123.1472754,
        lat: 49.2860663
      },
      {
        lng: -123.1390786,
        lat: 49.2772758
      },
      {
        lng: -123.1361175,
        lat: 49.2745879
      },
      {
        lng: -123.1377054,
        lat: 49.2727679
      },
      {
        lng: -123.1368683,
        lat: 49.2700937
      },
      {
        lng: -123.1338697,
        lat: 49.2687462
      },
      {
        lng: -123.1313539,
        lat: 49.2680076
      },
      {
        lng: -123.1294227,
        lat: 49.2687076
      }
    ]
  },
  {
    name: "Vancouver Zone 2",
    crane: 285.0,
    dump: 153.0,
    split: 160.0,
    bounds: [
      {
        lng: -123.1382203,
        lat: 49.2677906
      },
      {
        lng: -123.1390572,
        lat: 49.2491788
      },
      {
        lng: -123.076272,
        lat: 49.2485625
      },
      {
        lng: -123.0760038,
        lat: 49.2572112
      },
      {
        lng: -123.0775809,
        lat: 49.2582965
      },
      {
        lng: -123.0771303,
        lat: 49.2886346
      },
      {
        lng: -123.099575,
        lat: 49.2913497
      },
      {
        lng: -123.0997896,
        lat: 49.2785846
      },
      {
        lng: -123.1004763,
        lat: 49.2730269
      },
      {
        lng: -123.1069352,
        lat: 49.2729359
      },
      {
        lng: -123.1108189,
        lat: 49.2729569
      },
      {
        lng: -123.1131363,
        lat: 49.2725089
      },
      {
        lng: -123.1159258,
        lat: 49.2719209
      },
      {
        lng: -123.1233073,
        lat: 49.2692329
      },
      {
        lng: -123.1294441,
        lat: 49.2687006
      },
      {
        lng: -123.1313753,
        lat: 49.2680006
      },
      {
        lng: -123.1330275,
        lat: 49.2684627
      },
      {
        lng: -123.1338912,
        lat: 49.2687392
      },
      {
        lng: -123.1359244,
        lat: 49.2696807
      },
      {
        lng: -123.1368898,
        lat: 49.2700867
      },
      {
        lng: -123.1369543,
        lat: 49.2702827
      },
      {
        lng: -123.137877,
        lat: 49.2691697
      },
      {
        lng: -123.1381667,
        lat: 49.2685151
      },
      {
        lng: -123.1382203,
        lat: 49.2677906
      }
    ]
  },
  {
    name: "Vancouver Zone 4",
    crane: 285.0,
    dump: 153.0,
    split: 160.0,
    bounds: [
      {
        lng: -123.1388963,
        lat: 49.249927
      },
      {
        lng: -123.1411279,
        lat: 49.2005419
      },
      {
        lng: -123.1297981,
        lat: 49.1991959
      },
      {
        lng: -123.1201849,
        lat: 49.2028974
      },
      {
        lng: -123.1071385,
        lat: 49.2004298
      },
      {
        lng: -123.0894571,
        lat: 49.1990838
      },
      {
        lng: -123.0770115,
        lat: 49.2032619
      },
      {
        lng: -123.07699,
        lat: 49.2261375
      },
      {
        lng: -123.0761103,
        lat: 49.2492266
      },
      {
        lng: -123.1388963,
        lat: 49.249927
      }
    ]
  },
  {
    name: "Vancouver Zone 5",
    crane: 350.0,
    dump: 204.0,
    split: 212.0,
    bounds: [
      {
        lng: -123.1802955,
        lat: 49.2740754
      },
      {
        lng: -123.1960026,
        lat: 49.2741873
      },
      {
        lng: -123.1971184,
        lat: 49.2202868
      },
      {
        lng: -123.2088342,
        lat: 49.1999327
      },
      {
        lng: -123.217546,
        lat: 49.1798508
      },
      {
        lng: -123.2121846,
        lat: 49.1336546
      },
      {
        lng: -123.0865689,
        lat: 49.1338785
      },
      {
        lng: -123.0678578,
        lat: 49.1285994
      },
      {
        lng: -123.0691453,
        lat: 49.1667202
      },
      {
        lng: -123.0706903,
        lat: 49.2020358
      },
      {
        lng: -123.0894871,
        lat: 49.1981941
      },
      {
        lng: -123.1071681,
        lat: 49.1995401
      },
      {
        lng: -123.1202143,
        lat: 49.2020077
      },
      {
        lng: -123.1298274,
        lat: 49.1983062
      },
      {
        lng: -123.141157,
        lat: 49.1996523
      },
      {
        lng: -123.1381742,
        lat: 49.2685031
      },
      {
        lng: -123.1377141,
        lat: 49.2693644
      },
      {
        lng: -123.1369537,
        lat: 49.2701697
      },
      {
        lng: -123.1379725,
        lat: 49.273778
      },
      {
        lng: -123.1403246,
        lat: 49.2778769
      },
      {
        lng: -123.1470893,
        lat: 49.2803629
      },
      {
        lng: -123.1604473,
        lat: 49.2750304
      },
      {
        lng: -123.1802955,
        lat: 49.2740754
      }
    ]
  },
  {
    name: "Vancouver Zone 6",
    crane: 420.0,
    dump: 226.0,
    split: 234.0,
    bounds: [
      {
        lng: -123.1960033,
        lat: 49.2743003
      },
      {
        lng: -123.2023109,
        lat: 49.2778878
      },
      {
        lng: -123.252182,
        lat: 49.2875149
      },
      {
        lng: -123.2789612,
        lat: 49.2574983
      },
      {
        lng: -123.1972504,
        lat: 49.2205123
      },
      {
        lng: -123.1960033,
        lat: 49.2743003
      }
    ]
  },
  {
    name: "West Van Zone 3",
    crane: 355.0,
    dump: 212.0,
    split: 219.0,
    bounds: [
      {
        lng: -123.2364308,
        lat: 49.3490729
      },
      {
        lng: -123.236581,
        lat: 49.3592343
      },
      {
        lng: -123.268553,
        lat: 49.3689604
      },
      {
        lng: -123.2624104,
        lat: 49.3777034
      },
      {
        lng: -123.2805907,
        lat: 49.3827218
      },
      {
        lng: -123.2962655,
        lat: 49.3734385
      },
      {
        lng: -123.2896244,
        lat: 49.364433
      },
      {
        lng: -123.2861912,
        lat: 49.3580603
      },
      {
        lng: -123.2743465,
        lat: 49.3508482
      },
      {
        lng: -123.2722866,
        lat: 49.334575
      },
      {
        lng: -123.264991,
        lat: 49.328646
      },
      {
        lng: -123.2414069,
        lat: 49.3366849
      },
      {
        lng: -123.2048069,
        lat: 49.3372312
      },
      {
        lng: -123.1689136,
        lat: 49.3264243
      },
      {
        lng: -123.1572306,
        lat: 49.3247862
      },
      {
        lng: -123.1571231,
        lat: 49.3432155
      },
      {
        lng: -123.1657407,
        lat: 49.343986
      },
      {
        lng: -123.174294,
        lat: 49.3439451
      },
      {
        lng: -123.1802217,
        lat: 49.3443305
      },
      {
        lng: -123.1851674,
        lat: 49.3447869
      },
      {
        lng: -123.1894379,
        lat: 49.3468872
      },
      {
        lng: -123.1919494,
        lat: 49.3473131
      },
      {
        lng: -123.1972732,
        lat: 49.3473253
      },
      {
        lng: -123.2054349,
        lat: 49.346509
      },
      {
        lng: -123.2114339,
        lat: 49.3461335
      },
      {
        lng: -123.2191542,
        lat: 49.346492
      },
      {
        lng: -123.2252305,
        lat: 49.3478007
      },
      {
        lng: -123.2281027,
        lat: 49.3482199
      },
      {
        lng: -123.2314745,
        lat: 49.348812
      },
      {
        lng: -123.2364308,
        lat: 49.3490729
      }
    ]
  },
  {
    name: "West Van Zone 2",
    crane: 330.0,
    dump: 191.0,
    split: 197.0,
    bounds: [
      {
        lng: -123.236668,
        lat: 49.3594442
      },
      {
        lng: -123.2365822,
        lat: 49.3491011
      },
      {
        lng: -123.2316473,
        lat: 49.3488122
      },
      {
        lng: -123.2254034,
        lat: 49.3478009
      },
      {
        lng: -123.2209725,
        lat: 49.3468197
      },
      {
        lng: -123.2167777,
        lat: 49.3462858
      },
      {
        lng: -123.2115853,
        lat: 49.3461616
      },
      {
        lng: -123.2064359,
        lat: 49.3464566
      },
      {
        lng: -123.197446,
        lat: 49.3473255
      },
      {
        lng: -123.1921223,
        lat: 49.3473133
      },
      {
        lng: -123.1895893,
        lat: 49.3469154
      },
      {
        lng: -123.1860055,
        lat: 49.3450946
      },
      {
        lng: -123.1845358,
        lat: 49.3446453
      },
      {
        lng: -123.1744669,
        lat: 49.3439453
      },
      {
        lng: -123.1658921,
        lat: 49.3440142
      },
      {
        lng: -123.1572745,
        lat: 49.3432436
      },
      {
        lng: -123.1572104,
        lat: 49.3466037
      },
      {
        lng: -123.1571835,
        lat: 49.3503449
      },
      {
        lng: -123.1571567,
        lat: 49.3517379
      },
      {
        lng: -123.1572593,
        lat: 49.3529988
      },
      {
        lng: -123.1571886,
        lat: 49.3591228
      },
      {
        lng: -123.236668,
        lat: 49.3594442
      }
    ]
  },
  {
    name: "West Van Zone 1",
    crane: 309.0,
    dump: 168.0,
    split: 175.0,
    bounds: [
      {
        lng: -123.1566311,
        lat: 49.3609675
      },
      {
        lng: -123.1571032,
        lat: 49.3248136
      },
      {
        lng: -123.1412664,
        lat: 49.3204774
      },
      {
        lng: -123.1322753,
        lat: 49.326506
      },
      {
        lng: -123.1192291,
        lat: 49.3296945
      },
      {
        lng: -123.1174047,
        lat: 49.3435789
      },
      {
        lng: -123.1170614,
        lat: 49.3652719
      },
      {
        lng: -123.1309664,
        lat: 49.3705259
      },
      {
        lng: -123.1428114,
        lat: 49.361247
      },
      {
        lng: -123.1566311,
        lat: 49.3609675
      }
    ]
  },
  {
    name: "North Van Zone 4",
    crane: 290.0,
    dump: 146.0,
    split: 153.0,
    bounds: [
      {
        lng: -122.9895833,
        lat: 49.3052168
      },
      {
        lng: -122.954221,
        lat: 49.2989484
      },
      {
        lng: -122.944093,
        lat: 49.3054407
      },
      {
        lng: -122.9380849,
        lat: 49.315737
      },
      {
        lng: -122.933965,
        lat: 49.3255836
      },
      {
        lng: -122.9363682,
        lat: 49.3340859
      },
      {
        lng: -122.9689839,
        lat: 49.328828
      },
      {
        lng: -122.9894116,
        lat: 49.329723
      },
      {
        lng: -122.9895833,
        lat: 49.3052168
      }
    ]
  },
  {
    name: "North Van Zone 2",
    crane: 285.0,
    dump: 146.0,
    split: 153.0,
    bounds: [
      {
        lng: -123.0903483,
        lat: 49.3198912
      },
      {
        lng: -123.0817652,
        lat: 49.3194436
      },
      {
        lng: -123.0795769,
        lat: 49.3192191
      },
      {
        lng: -123.065629,
        lat: 49.3137366
      },
      {
        lng: -123.0509519,
        lat: 49.3159187
      },
      {
        lng: -123.0408668,
        lat: 49.3195275
      },
      {
        lng: -123.0335283,
        lat: 49.313261
      },
      {
        lng: -123.0306535,
        lat: 49.3197511
      },
      {
        lng: -123.0266189,
        lat: 49.3254297
      },
      {
        lng: -123.0200529,
        lat: 49.3358336
      },
      {
        lng: -123.087945,
        lat: 49.3368404
      },
      {
        lng: -123.0905199,
        lat: 49.327891
      },
      {
        lng: -123.0903483,
        lat: 49.3198912
      }
    ]
  },
  {
    name: "North Van Zone 3",
    crane: 295.0,
    dump: 153.0,
    split: 160.0,
    bounds: [
      {
        lng: -123.089962005615,
        lat: 49.3132050058364
      },
      {
        lng: -123.090648651123,
        lat: 49.3278630491399
      },
      {
        lng: -123.088073730469,
        lat: 49.3367564520212
      },
      {
        lng: -123.020181655884,
        lat: 49.3357497323454
      },
      {
        lng: -123.012542724609,
        lat: 49.3473257654428
      },
      {
        lng: -123.027477264404,
        lat: 49.3642095864228
      },
      {
        lng: -123.0930519104,
        lat: 49.3692400677643
      },
      {
        lng: -123.102493286133,
        lat: 49.3710285593175
      },
      {
        lng: -123.116054534912,
        lat: 49.3637624076168
      },
      {
        lng: -123.116998672485,
        lat: 49.3385461250468
      },
      {
        lng: -123.118629455566,
        lat: 49.3297089818687
      },
      {
        lng: -123.131675720215,
        lat: 49.3265205091375
      },
      {
        lng: -123.141975402832,
        lat: 49.3191358847382
      },
      {
        lng: -123.123092651367,
        lat: 49.3092879961586
      },
      {
        lng: -123.107986450195,
        lat: 49.309064157627
      },
      {
        lng: -123.089962005615,
        lat: 49.3132050058364
      }
    ]
  },
  {
    name: "Richmond/Delta Zone 1",
    crane: 325.0,
    dump: 181.0,
    split: 191.0,
    bounds: [
      {
        lng: -123.2108123,
        lat: 49.1341042
      },
      {
        lng: -123.2121856,
        lat: 49.1062418
      },
      {
        lng: -123.1709866,
        lat: 49.067568
      },
      {
        lng: -123.1174279,
        lat: 49.0405683
      },
      {
        lng: -123.1090164,
        lat: 49.002519
      },
      {
        lng: -123.0238718,
        lat: 49.0021811
      },
      {
        lng: -123.0302233,
        lat: 49.0162561
      },
      {
        lng: -123.0305665,
        lat: 49.0466445
      },
      {
        lng: -122.9647654,
        lat: 49.0664702
      },
      {
        lng: -122.8889446,
        lat: 49.0891571
      },
      {
        lng: -123.0569178,
        lat: 49.0901964
      },
      {
        lng: -123.057261,
        lat: 49.0953526
      },
      {
        lng: -123.057261,
        lat: 49.1018225
      },
      {
        lng: -123.0573468,
        lat: 49.1056054
      },
      {
        lng: -123.057776,
        lat: 49.1084892
      },
      {
        lng: -123.061336,
        lat: 49.1104137
      },
      {
        lng: -123.06773,
        lat: 49.1155965
      },
      {
        lng: -123.0727515,
        lat: 49.119571
      },
      {
        lng: -123.0779455,
        lat: 49.1236577
      },
      {
        lng: -123.0674741,
        lat: 49.1291621
      },
      {
        lng: -123.085842,
        lat: 49.1341043
      },
      {
        lng: -123.1584553,
        lat: 49.1341043
      },
      {
        lng: -123.2108123,
        lat: 49.1341042
      }
    ]
  },
  {
    name: "Richmond Zone 2",
    crane: 285.0,
    dump: 153.0,
    split: 160.0,
    bounds: [
      {
        lng: -123.070821762085,
        lat: 49.2022613368392
      },
      {
        lng: -123.067989349365,
        lat: 49.1288249276717
      },
      {
        lng: -123.037605285645,
        lat: 49.1469065049579
      },
      {
        lng: -122.976493835449,
        lat: 49.1570113447582
      },
      {
        lng: -122.977867126465,
        lat: 49.1792347375617
      },
      {
        lng: -123.011856079102,
        lat: 49.1949422279318
      },
      {
        lng: -123.038291931152,
        lat: 49.2021211342007
      },
      {
        lng: -123.059577941895,
        lat: 49.2032427441791
      },
      {
        lng: -123.070821762085,
        lat: 49.2022613368392
      }
    ]
  },
  {
    name: "Surrey Zone 2",
    crane: 215.0,
    dump: 116.0,
    split: 124.0,
    bounds: [
      {
        lng: -122.918474,
        lat: 49.1771029
      },
      {
        lng: -122.9305753,
        lat: 49.1665256
      },
      {
        lng: -122.9195032,
        lat: 49.1624559
      },
      {
        lng: -122.9207056,
        lat: 49.1492926
      },
      {
        lng: -122.8824246,
        lat: 49.1483102
      },
      {
        lng: -122.8456883,
        lat: 49.1480301
      },
      {
        lng: -122.8455598,
        lat: 49.1049206
      },
      {
        lng: -122.7347508,
        lat: 49.1043587
      },
      {
        lng: -122.7350301,
        lat: 49.1217302
      },
      {
        lng: -122.7347943,
        lat: 49.1337951
      },
      {
        lng: -122.7346655,
        lat: 49.1556454
      },
      {
        lng: -122.7344293,
        lat: 49.1665144
      },
      {
        lng: -122.7347494,
        lat: 49.1772416
      },
      {
        lng: -122.918474,
        lat: 49.1771029
      }
    ]
  },
  {
    name: "Surrey/Delta Zone 3",
    crane: 275.0,
    dump: 139.0,
    split: 146.0,
    bounds: [
      {
        lng: -122.9226361,
        lat: 49.1344973
      },
      {
        lng: -122.9288146,
        lat: 49.1342722
      },
      {
        lng: -122.9272697,
        lat: 49.1197249
      },
      {
        lng: -122.9214966,
        lat: 49.1159052
      },
      {
        lng: -122.9119479,
        lat: 49.1139951
      },
      {
        lng: -122.9058976,
        lat: 49.1111856
      },
      {
        lng: -122.9017984,
        lat: 49.1054255
      },
      {
        lng: -122.8942878,
        lat: 49.0935116
      },
      {
        lng: -122.8898471,
        lat: 49.0893248
      },
      {
        lng: -122.8595273,
        lat: 49.0863616
      },
      {
        lng: -122.8510952,
        lat: 49.083957
      },
      {
        lng: -122.8300132,
        lat: 49.0744959
      },
      {
        lng: -122.8257148,
        lat: 49.0705159
      },
      {
        lng: -122.8224403,
        lat: 49.0698092
      },
      {
        lng: -122.8188968,
        lat: 49.0668213
      },
      {
        lng: -122.7927721,
        lat: 49.0457716
      },
      {
        lng: -122.7846613,
        lat: 49.0457294
      },
      {
        lng: -122.7686968,
        lat: 49.0314238
      },
      {
        lng: -122.7514876,
        lat: 49.0314953
      },
      {
        lng: -122.7343642,
        lat: 49.0314799
      },
      {
        lng: -122.7349863,
        lat: 49.0698035
      },
      {
        lng: -122.7342783,
        lat: 49.1042467
      },
      {
        lng: -122.8457307,
        lat: 49.1046962
      },
      {
        lng: -122.8456445,
        lat: 49.1184931
      },
      {
        lng: -122.8456445,
        lat: 49.1265878
      },
      {
        lng: -122.8458166,
        lat: 49.1480578
      },
      {
        lng: -122.8819517,
        lat: 49.1484145
      },
      {
        lng: -122.9210919,
        lat: 49.1493203
      },
      {
        lng: -122.9226361,
        lat: 49.1344973
      }
    ]
  },
  {
    name: "Howe Sound Zone 1",
    crane: 535.0,
    dump: 285.0,
    split: 292.0,
    bounds: [
      {
        lng: -123.2624817,
        lat: 49.5430335
      },
      {
        lng: -123.2556152,
        lat: 49.4020374
      },
      {
        lng: -123.2710648,
        lat: 49.3806406
      },
      {
        lng: -123.2624104,
        lat: 49.3777034
      },
      {
        lng: -123.2157898,
        lat: 49.4324126
      },
      {
        lng: -123.2363892,
        lat: 49.5439246
      },
      {
        lng: -123.2624817,
        lat: 49.5430335
      }
    ]
  },
  {
    name: "Squamish Zone 1",
    crane: 880.0,
    dump: 438.0,
    split: 444.0,
    bounds: [
      {
        lng: -123.203430175781,
        lat: 49.6889548788703
      },
      {
        lng: -123.123779296875,
        lat: 49.6774038844834
      },
      {
        lng: -123.06884765625,
        lat: 49.746668691468
      },
      {
        lng: -123.125152587891,
        lat: 49.8238090851325
      },
      {
        lng: -123.239135742188,
        lat: 49.8282387087905
      },
      {
        lng: -123.158111572266,
        lat: 49.744893904611
      },
      {
        lng: -123.203430175781,
        lat: 49.6889548788703
      }
    ]
  },
  {
    name: "Whistler",
    crane: 1050.0,
    dump: 547.0,
    split: 554.0,
    bounds: [
      {
        lng: -122.994689941406,
        lat: 50.1628243338173
      },
      {
        lng: -123.027648925781,
        lat: 50.1012027698295
      },
      {
        lng: -123.127899169922,
        lat: 50.0641917366591
      },
      {
        lng: -123.072967529297,
        lat: 50.0536119068041
      },
      {
        lng: -122.969970703125,
        lat: 50.0791758353569
      },
      {
        lng: -122.906799316406,
        lat: 50.142586001414
      },
      {
        lng: -122.994689941406,
        lat: 50.1628243338173
      }
    ]
  },
  {
    name: "Tri City Zone 2",
    crane: 159.0,
    dump: 95.0,
    split: 103.0,
    bounds: [
      {
        lng: -122.8272675,
        lat: 49.2810547
      },
      {
        lng: -122.8571365,
        lat: 49.2838542
      },
      {
        lng: -122.8615998,
        lat: 49.2893407
      },
      {
        lng: -122.8670499,
        lat: 49.2900685
      },
      {
        lng: -122.8668779,
        lat: 49.2783942
      },
      {
        lng: -122.8713842,
        lat: 49.2781987
      },
      {
        lng: -122.8723713,
        lat: 49.2745871
      },
      {
        lng: -122.874324,
        lat: 49.2748532
      },
      {
        lng: -122.8749891,
        lat: 49.2743073
      },
      {
        lng: -122.8764484,
        lat: 49.2725222
      },
      {
        lng: -122.8783797,
        lat: 49.2707372
      },
      {
        lng: -122.8806112,
        lat: 49.2690781
      },
      {
        lng: -122.8819519,
        lat: 49.2698242
      },
      {
        lng: -122.8933455,
        lat: 49.2696459
      },
      {
        lng: -122.8931902,
        lat: 49.2656969
      },
      {
        lng: -122.8930994,
        lat: 49.2628962
      },
      {
        lng: -122.8930081,
        lat: 49.2603962
      },
      {
        lng: -122.8931288,
        lat: 49.2589713
      },
      {
        lng: -122.8930457,
        lat: 49.2564014
      },
      {
        lng: -122.8929223,
        lat: 49.2529055
      },
      {
        lng: -122.8928767,
        lat: 49.2508353
      },
      {
        lng: -122.8928097,
        lat: 49.2490594
      },
      {
        lng: -122.8472499,
        lat: 49.2490612
      },
      {
        lng: -122.8018617,
        lat: 49.2492414
      },
      {
        lng: -122.7973986,
        lat: 49.2597734
      },
      {
        lng: -122.7847816,
        lat: 49.2627982
      },
      {
        lng: -122.7790309,
        lat: 49.2687351
      },
      {
        lng: -122.7759409,
        lat: 49.2751193
      },
      {
        lng: -122.7728511,
        lat: 49.284638
      },
      {
        lng: -122.7992869,
        lat: 49.285058
      },
      {
        lng: -122.8044463,
        lat: 49.2851356
      },
      {
        lng: -122.8073121,
        lat: 49.284694
      },
      {
        lng: -122.8115177,
        lat: 49.2841761
      },
      {
        lng: -122.8140066,
        lat: 49.2838542
      },
      {
        lng: -122.8195954,
        lat: 49.2850516
      },
      {
        lng: -122.821312,
        lat: 49.2846317
      },
      {
        lng: -122.8272675,
        lat: 49.2810547
      }
    ]
  },
  {
    name: "Tri City Zone 5",
    crane: 195.0,
    dump: 109.0,
    split: 116.0,
    bounds: [
      {
        lng: -122.8319052,
        lat: 49.3292186
      },
      {
        lng: -122.8350809,
        lat: 49.2996751
      },
      {
        lng: -122.8334073,
        lat: 49.2983318
      },
      {
        lng: -122.8332785,
        lat: 49.2965687
      },
      {
        lng: -122.8315619,
        lat: 49.2963168
      },
      {
        lng: -122.8216056,
        lat: 49.2968765
      },
      {
        lng: -122.8123359,
        lat: 49.2941897
      },
      {
        lng: -122.8034096,
        lat: 49.2944136
      },
      {
        lng: -122.7974014,
        lat: 49.2963168
      },
      {
        lng: -122.7903633,
        lat: 49.2946375
      },
      {
        lng: -122.7852135,
        lat: 49.2927343
      },
      {
        lng: -122.7766304,
        lat: 49.2936299
      },
      {
        lng: -122.7716523,
        lat: 49.2953092
      },
      {
        lng: -122.7611809,
        lat: 49.2931821
      },
      {
        lng: -122.7551728,
        lat: 49.2928463
      },
      {
        lng: -122.7464181,
        lat: 49.2928463
      },
      {
        lng: -122.7464181,
        lat: 49.2859045
      },
      {
        lng: -122.7384359,
        lat: 49.2851767
      },
      {
        lng: -122.7390008,
        lat: 49.271585
      },
      {
        lng: -122.7133733,
        lat: 49.27185
      },
      {
        lng: -122.6873237,
        lat: 49.2900193
      },
      {
        lng: -122.6798136,
        lat: 49.3166872
      },
      {
        lng: -122.8319052,
        lat: 49.3292186
      }
    ]
  },
  {
    name: "Tri City Zone 3",
    crane: 159.0,
    dump: 95.0,
    split: 103.0,
    bounds: [
      {
        lng: -122.7771091,
        lat: 49.2712768
      },
      {
        lng: -122.7848339,
        lat: 49.2628757
      },
      {
        lng: -122.797451,
        lat: 49.259851
      },
      {
        lng: -122.8013134,
        lat: 49.249431
      },
      {
        lng: -122.7625411,
        lat: 49.2494173
      },
      {
        lng: -122.7626923,
        lat: 49.236218
      },
      {
        lng: -122.7300739,
        lat: 49.2482544
      },
      {
        lng: -122.7181864,
        lat: 49.2569381
      },
      {
        lng: -122.7130795,
        lat: 49.2716689
      },
      {
        lng: -122.7771091,
        lat: 49.2712768
      }
    ]
  },
  {
    name: "Tri City Zone 4",
    crane: 175.0,
    dump: 103.0,
    split: 109.0,
    bounds: [
      {
        lng: -122.8734109,
        lat: 49.3086444
      },
      {
        lng: -122.8733251,
        lat: 49.3010613
      },
      {
        lng: -122.8951475,
        lat: 49.2930635
      },
      {
        lng: -122.8933563,
        lat: 49.2696668
      },
      {
        lng: -122.8819519,
        lat: 49.2698242
      },
      {
        lng: -122.8806112,
        lat: 49.2690781
      },
      {
        lng: -122.8764484,
        lat: 49.2725222
      },
      {
        lng: -122.8749891,
        lat: 49.2743073
      },
      {
        lng: -122.874324,
        lat: 49.2748532
      },
      {
        lng: -122.8723713,
        lat: 49.2745871
      },
      {
        lng: -122.8713842,
        lat: 49.2781987
      },
      {
        lng: -122.8668779,
        lat: 49.2783942
      },
      {
        lng: -122.8670499,
        lat: 49.2900685
      },
      {
        lng: -122.8474212,
        lat: 49.2872783
      },
      {
        lng: -122.8351598,
        lat: 49.2818683
      },
      {
        lng: -122.8274488,
        lat: 49.2812164
      },
      {
        lng: -122.821312,
        lat: 49.2846317
      },
      {
        lng: -122.8195954,
        lat: 49.2850516
      },
      {
        lng: -122.817793,
        lat: 49.2846317
      },
      {
        lng: -122.8144027,
        lat: 49.2837919
      },
      {
        lng: -122.8044463,
        lat: 49.2851356
      },
      {
        lng: -122.7730325,
        lat: 49.2847997
      },
      {
        lng: -122.7773669,
        lat: 49.271361
      },
      {
        lng: -122.7390008,
        lat: 49.271585
      },
      {
        lng: -122.7382712,
        lat: 49.2850796
      },
      {
        lng: -122.7462535,
        lat: 49.2858075
      },
      {
        lng: -122.7462535,
        lat: 49.2927492
      },
      {
        lng: -122.7610162,
        lat: 49.2930851
      },
      {
        lng: -122.7714875,
        lat: 49.2952122
      },
      {
        lng: -122.7765944,
        lat: 49.2935329
      },
      {
        lng: -122.7802422,
        lat: 49.2930571
      },
      {
        lng: -122.7850487,
        lat: 49.2926373
      },
      {
        lng: -122.7903272,
        lat: 49.2945405
      },
      {
        lng: -122.7972366,
        lat: 49.2962197
      },
      {
        lng: -122.8032448,
        lat: 49.2943166
      },
      {
        lng: -122.8121711,
        lat: 49.2940927
      },
      {
        lng: -122.8214408,
        lat: 49.2967795
      },
      {
        lng: -122.831397,
        lat: 49.2962197
      },
      {
        lng: -122.8337558,
        lat: 49.2965488
      },
      {
        lng: -122.8361146,
        lat: 49.2968778
      },
      {
        lng: -122.8377778,
        lat: 49.2966242
      },
      {
        lng: -122.8396985,
        lat: 49.2970422
      },
      {
        lng: -122.8437118,
        lat: 49.2987177
      },
      {
        lng: -122.8479623,
        lat: 49.3027402
      },
      {
        lng: -122.8555123,
        lat: 49.3065043
      },
      {
        lng: -122.8734109,
        lat: 49.3086444
      }
    ]
  },
  {
    name: "Bowen Island",
    crane: 970.0,
    dump: 554.0,
    split: 547.0,
    bounds: [
      {
        lng: -123.417663574219,
        lat: 49.3939937133246
      },
      {
        lng: -123.443756103516,
        lat: 49.3618059525236
      },
      {
        lng: -123.436889648438,
        lat: 49.32512199104
      },
      {
        lng: -123.3544921875,
        lat: 49.3269120870866
      },
      {
        lng: -123.310546875,
        lat: 49.3653834114396
      },
      {
        lng: -123.292694091797,
        lat: 49.4172273199647
      },
      {
        lng: -123.358612060547,
        lat: 49.4216940608492
      },
      {
        lng: -123.417663574219,
        lat: 49.3939937133246
      }
    ]
  },
  {
    name: "Pitt Meadows Zone 1",
    crane: 189.0,
    dump: 103.0,
    split: 109.0,
    bounds: [
      {
        lng: -122.6555729,
        lat: 49.2416985
      },
      {
        lng: -122.6561307,
        lat: 49.2711368
      },
      {
        lng: -122.7061272,
        lat: 49.2716129
      },
      {
        lng: -122.7202034,
        lat: 49.2518961
      },
      {
        lng: -122.7630758,
        lat: 49.2316671
      },
      {
        lng: -122.7579689,
        lat: 49.2193911
      },
      {
        lng: -122.7140236,
        lat: 49.2068317
      },
      {
        lng: -122.6657867,
        lat: 49.1975223
      },
      {
        lng: -122.6686172,
        lat: 49.2086495
      },
      {
        lng: -122.667873,
        lat: 49.2123314
      },
      {
        lng: -122.6680714,
        lat: 49.2159259
      },
      {
        lng: -122.6699917,
        lat: 49.2206744
      },
      {
        lng: -122.669607,
        lat: 49.2226936
      },
      {
        lng: -122.6671932,
        lat: 49.2245851
      },
      {
        lng: -122.6657234,
        lat: 49.2267009
      },
      {
        lng: -122.665498,
        lat: 49.2293772
      },
      {
        lng: -122.6637276,
        lat: 49.2318853
      },
      {
        lng: -122.657033,
        lat: 49.2326146
      },
      {
        lng: -122.6555729,
        lat: 49.2416985
      }
    ]
  },
  {
    name: "Maple Ridge Zone 1",
    crane: 189.0,
    dump: 109.0,
    split: 116.0,
    bounds: [
      {
        lng: -122.6225708,
        lat: 49.2425672
      },
      {
        lng: -122.6557444,
        lat: 49.2422871
      },
      {
        lng: -122.657033,
        lat: 49.2326146
      },
      {
        lng: -122.6637276,
        lat: 49.2318853
      },
      {
        lng: -122.665498,
        lat: 49.2293772
      },
      {
        lng: -122.6657234,
        lat: 49.2267009
      },
      {
        lng: -122.6671932,
        lat: 49.2245851
      },
      {
        lng: -122.669607,
        lat: 49.2226936
      },
      {
        lng: -122.6698421,
        lat: 49.2201999
      },
      {
        lng: -122.6680714,
        lat: 49.2159259
      },
      {
        lng: -122.667873,
        lat: 49.2123314
      },
      {
        lng: -122.6686172,
        lat: 49.2086495
      },
      {
        lng: -122.6685751,
        lat: 49.2068992
      },
      {
        lng: -122.6657867,
        lat: 49.1975223
      },
      {
        lng: -122.6229566,
        lat: 49.2125238
      },
      {
        lng: -122.6225708,
        lat: 49.2425672
      }
    ]
  },
  {
    name: "Maple Ridge Zone 3",
    crane: 215.0,
    dump: 124.0,
    split: 131.0,
    bounds: [
      {
        lng: -122.6564744,
        lat: 49.2704227
      },
      {
        lng: -122.656318,
        lat: 49.2704234
      },
      {
        lng: -122.6563459,
        lat: 49.2712068
      },
      {
        lng: -122.6564744,
        lat: 49.2704227
      }
    ]
  },
  {
    name: "Maple Ridge Zone 3",
    crane: 215.0,
    dump: 124.0,
    split: 131.0,
    bounds: [
      {
        lng: -122.6560886,
        lat: 49.2711363
      },
      {
        lng: -122.6557023,
        lat: 49.2422867
      },
      {
        lng: -122.6221851,
        lat: 49.2424972
      },
      {
        lng: -122.6015282,
        lat: 49.2420283
      },
      {
        lng: -122.6019297,
        lat: 49.2091864
      },
      {
        lng: -122.5876817,
        lat: 49.1989106
      },
      {
        lng: -122.5540361,
        lat: 49.1772573
      },
      {
        lng: -122.5543795,
        lat: 49.2232454
      },
      {
        lng: -122.5592718,
        lat: 49.2420209
      },
      {
        lng: -122.5626705,
        lat: 49.255163
      },
      {
        lng: -122.6297389,
        lat: 49.2708284
      },
      {
        lng: -122.6560886,
        lat: 49.2711363
      }
    ]
  },
  {
    name: "Maple Ridge Zone 5",
    crane: 275.0,
    dump: 146.0,
    split: 153.0,
    bounds: [
      {
        lng: -122.4691916,
        lat: 49.218382
      },
      {
        lng: -122.4693632,
        lat: 49.1716035
      },
      {
        lng: -122.4587202,
        lat: 49.1716036
      },
      {
        lng: -122.4240446,
        lat: 49.16891
      },
      {
        lng: -122.4061918,
        lat: 49.1971857
      },
      {
        lng: -122.3722029,
        lat: 49.2084018
      },
      {
        lng: -122.3546934,
        lat: 49.2265665
      },
      {
        lng: -122.3636198,
        lat: 49.2395691
      },
      {
        lng: -122.4693632,
        lat: 49.2502153
      },
      {
        lng: -122.4691916,
        lat: 49.218382
      }
    ]
  },
  {
    name: "Abbotsford Zone 1",
    crane: 345.0,
    dump: 192.0,
    split: 198.0,
    bounds: [
      {
        lng: -122.2929382,
        lat: 49.1246686
      },
      {
        lng: -122.3129351,
        lat: 49.1203522
      },
      {
        lng: -122.3769199,
        lat: 49.132794
      },
      {
        lng: -122.383225,
        lat: 49.1308925
      },
      {
        lng: -122.3794556,
        lat: 49.0018439
      },
      {
        lng: -122.2414398,
        lat: 49.0022944
      },
      {
        lng: -122.2428131,
        lat: 49.0342667
      },
      {
        lng: -122.2428131,
        lat: 49.1012968
      },
      {
        lng: -122.2929382,
        lat: 49.1246686
      }
    ]
  },
  {
    name: "Langley Zone 2",
    crane: 289.0,
    dump: 151.0,
    split: 158.0,
    bounds: [
      {
        lng: -122.5553079,
        lat: 49.1667122
      },
      {
        lng: -122.5596437,
        lat: 49.1203124
      },
      {
        lng: -122.5588704,
        lat: 49.0733736
      },
      {
        lng: -122.5250195,
        lat: 49.0657926
      },
      {
        lng: -122.4925742,
        lat: 49.0583848
      },
      {
        lng: -122.4287597,
        lat: 49.056958
      },
      {
        lng: -122.4038376,
        lat: 49.0574917
      },
      {
        lng: -122.381256,
        lat: 49.0557857
      },
      {
        lng: -122.3839116,
        lat: 49.1306117
      },
      {
        lng: -122.4024507,
        lat: 49.1508255
      },
      {
        lng: -122.4463951,
        lat: 49.1656438
      },
      {
        lng: -122.5157448,
        lat: 49.1633989
      },
      {
        lng: -122.5553079,
        lat: 49.1667122
      }
    ]
  },
  {
    name: "Surrey Zone 4",
    crane: 325.0,
    dump: 182.0,
    split: 185.0,
    bounds: [
      {
        lng: -122.8618669,
        lat: 49.0864585
      },
      {
        lng: -122.8934523,
        lat: 49.0560949
      },
      {
        lng: -122.875943,
        lat: 49.0223358
      },
      {
        lng: -122.824445,
        lat: 49.0194089
      },
      {
        lng: -122.7581843,
        lat: 49.0018441
      },
      {
        lng: -122.3791975,
        lat: 49.0020127
      },
      {
        lng: -122.3805687,
        lat: 49.0308899
      },
      {
        lng: -122.5587153,
        lat: 49.0308902
      },
      {
        lng: -122.7690846,
        lat: 49.0313123
      },
      {
        lng: -122.7770657,
        lat: 49.0385357
      },
      {
        lng: -122.7850491,
        lat: 49.0456179
      },
      {
        lng: -122.7931598,
        lat: 49.0456601
      },
      {
        lng: -122.8093005,
        lat: 49.0586495
      },
      {
        lng: -122.822828,
        lat: 49.0696977
      },
      {
        lng: -122.8261025,
        lat: 49.0704044
      },
      {
        lng: -122.8307229,
        lat: 49.0744828
      },
      {
        lng: -122.8510093,
        lat: 49.0837602
      },
      {
        lng: -122.8599149,
        lat: 49.0862501
      },
      {
        lng: -122.8618669,
        lat: 49.0864585
      }
    ]
  },
  {
    name: "Langley Zone 1",
    crane: 250.0,
    dump: 132.0,
    split: 138.0,
    bounds: [
      {
        lng: -122.7347943,
        lat: 49.1337951
      },
      {
        lng: -122.6894764,
        lat: 49.133205
      },
      {
        lng: -122.6369467,
        lat: 49.1328686
      },
      {
        lng: -122.622846,
        lat: 49.1253408
      },
      {
        lng: -122.6226689,
        lat: 49.1197788
      },
      {
        lng: -122.5594111,
        lat: 49.1175046
      },
      {
        lng: -122.5587404,
        lat: 49.1549413
      },
      {
        lng: -122.5585328,
        lat: 49.1611401
      },
      {
        lng: -122.5549528,
        lat: 49.1627803
      },
      {
        lng: -122.5548057,
        lat: 49.1679563
      },
      {
        lng: -122.6036443,
        lat: 49.2057115
      },
      {
        lng: -122.6256175,
        lat: 49.2104218
      },
      {
        lng: -122.6736837,
        lat: 49.188212
      },
      {
        lng: -122.7348822,
        lat: 49.1900912
      },
      {
        lng: -122.7344947,
        lat: 49.1621398
      },
      {
        lng: -122.7346875,
        lat: 49.1481361
      },
      {
        lng: -122.734741,
        lat: 49.1409517
      },
      {
        lng: -122.7347943,
        lat: 49.1337951
      }
    ]
  },
  {
    name: "Langley Zone 3",
    crane: 299.0,
    dump: 160.0,
    split: 169.0,
    bounds: [
      {
        lng: -122.7347943,
        lat: 49.1337951
      },
      {
        lng: -122.7351812,
        lat: 49.0919216
      },
      {
        lng: -122.73561,
        lat: 49.070549
      },
      {
        lng: -122.7353951,
        lat: 49.0603266
      },
      {
        lng: -122.7353949,
        lat: 49.0500761
      },
      {
        lng: -122.7353095,
        lat: 49.0406942
      },
      {
        lng: -122.7350089,
        lat: 49.0311996
      },
      {
        lng: -122.5578967,
        lat: 49.0307776
      },
      {
        lng: -122.5588874,
        lat: 49.0306089
      },
      {
        lng: -122.3807418,
        lat: 49.0306085
      },
      {
        lng: -122.3811709,
        lat: 49.0556732
      },
      {
        lng: -122.4037525,
        lat: 49.0573792
      },
      {
        lng: -122.4290808,
        lat: 49.0569147
      },
      {
        lng: -122.4778504,
        lat: 49.0581075
      },
      {
        lng: -122.4925646,
        lat: 49.0591367
      },
      {
        lng: -122.5248228,
        lat: 49.0666889
      },
      {
        lng: -122.5590661,
        lat: 49.0742031
      },
      {
        lng: -122.5593256,
        lat: 49.1173921
      },
      {
        lng: -122.6229269,
        lat: 49.1193293
      },
      {
        lng: -122.623104,
        lat: 49.1248914
      },
      {
        lng: -122.6372046,
        lat: 49.1324192
      },
      {
        lng: -122.7347943,
        lat: 49.1337951
      }
    ]
  },
  {
    name: "Mission Zone 2",
    crane: 350.0,
    dump: 202.0,
    split: 219.0,
    bounds: [
      {
        lng: -122.2640999,
        lat: 49.1478047
      },
      {
        lng: -122.2637566,
        lat: 49.1474678
      },
      {
        lng: -122.2637358,
        lat: 49.1476802
      },
      {
        lng: -122.2640999,
        lat: 49.1478047
      }
    ]
  },

  {
    name: "Mission Zone 2",
    crane: 350.0,
    dump: 202.0,
    split: 219.0,
    bounds: [
      {
        lng: -122.2639933,
        lat: 49.1471469
      },
      {
        lng: -122.249331,
        lat: 49.1427529
      },
      {
        lng: -122.2101121,
        lat: 49.1330368
      },
      {
        lng: -122.1054834,
        lat: 49.1526327
      },
      {
        lng: -122.0695629,
        lat: 49.1562816
      },
      {
        lng: -122.0687213,
        lat: 49.1683865
      },
      {
        lng: -122.0733307,
        lat: 49.1796764
      },
      {
        lng: -122.0974909,
        lat: 49.1891805
      },
      {
        lng: -122.1765142,
        lat: 49.2199761
      },
      {
        lng: -122.2558601,
        lat: 49.23206
      },
      {
        lng: -122.3503636,
        lat: 49.2363618
      },
      {
        lng: -122.3680282,
        lat: 49.207492
      },
      {
        lng: -122.4010374,
        lat: 49.1960684
      },
      {
        lng: -122.351326,
        lat: 49.1795855
      },
      {
        lng: -122.3274985,
        lat: 49.1799631
      },
      {
        lng: -122.3074238,
        lat: 49.1803412
      },
      {
        lng: -122.2654732,
        lat: 49.1805814
      },
      {
        lng: -122.2639933,
        lat: 49.1471469
      }
    ]
  },
  {
    name: "Surrey Zone 1",
    crane: 175.0,
    dump: 103.0,
    split: 109.0,
    bounds: [
      {
        lng: -122.7449213,
        lat: 49.2137891
      },
      {
        lng: -122.7686104,
        lat: 49.2158583
      },
      {
        lng: -122.7554097,
        lat: 49.2144804
      },
      {
        lng: -122.7449213,
        lat: 49.2137891
      }
    ]
  },
  {
    name: "Surrey Zone 1",
    crane: 175.0,
    dump: 103.0,
    split: 109.0,
    bounds: [
      {
        lng: -122.8760285,
        lat: 49.2205957
      },
      {
        lng: -122.9214333,
        lat: 49.1770176
      },
      {
        lng: -122.7353511,
        lat: 49.1771298
      },
      {
        lng: -122.7347494,
        lat: 49.1772416
      },
      {
        lng: -122.734921,
        lat: 49.1893038
      },
      {
        lng: -122.7350068,
        lat: 49.1815621
      },
      {
        lng: -122.7494461,
        lat: 49.1853143
      },
      {
        lng: -122.7777056,
        lat: 49.1914718
      },
      {
        lng: -122.8125961,
        lat: 49.1914343
      },
      {
        lng: -122.8128556,
        lat: 49.2035207
      },
      {
        lng: -122.8119111,
        lat: 49.2167273
      },
      {
        lng: -122.8760285,
        lat: 49.2205957
      }
    ]
  },
  {
    name: "Tri City Zone 6",
    crane: 204.0,
    dump: 116.0,
    split: 124.0,
    bounds: [
      {
        lng: -122.8321627,
        lat: 49.3292186
      },
      {
        lng: -122.9113881,
        lat: 49.3315692
      },
      {
        lng: -122.9366223,
        lat: 49.3170242
      },
      {
        lng: -122.926666,
        lat: 49.2937432
      },
      {
        lng: -122.9088381,
        lat: 49.2934871
      },
      {
        lng: -122.8733251,
        lat: 49.3010613
      },
      {
        lng: -122.8734109,
        lat: 49.3086444
      },
      {
        lng: -122.8557698,
        lat: 49.3065043
      },
      {
        lng: -122.8482197,
        lat: 49.3027402
      },
      {
        lng: -122.8439693,
        lat: 49.2987177
      },
      {
        lng: -122.839956,
        lat: 49.2970422
      },
      {
        lng: -122.8377778,
        lat: 49.2966242
      },
      {
        lng: -122.8361146,
        lat: 49.2968778
      },
      {
        lng: -122.8333481,
        lat: 49.2964788
      },
      {
        lng: -122.8334073,
        lat: 49.2983318
      },
      {
        lng: -122.8350809,
        lat: 49.2996751
      },
      {
        lng: -122.8321627,
        lat: 49.3292186
      }
    ]
  },
  {
    name: "Harrison Area",
    crane: 450.0,
    dump: 292.0,
    split: 299.0,
    bounds: [
      {
        lng: -122.0762049,
        lat: 49.2048848
      },
      {
        lng: -122.0974909,
        lat: 49.1891805
      },
      {
        lng: -122.0733307,
        lat: 49.1796764
      },
      {
        lng: -122.0687213,
        lat: 49.1683865
      },
      {
        lng: -122.0695629,
        lat: 49.1562816
      },
      {
        lng: -121.9349275,
        lat: 49.2231629
      },
      {
        lng: -121.7057622,
        lat: 49.2019677
      },
      {
        lng: -121.7397486,
        lat: 49.3195992
      },
      {
        lng: -121.8296991,
        lat: 49.3191517
      },
      {
        lng: -122.0762049,
        lat: 49.2048848
      }
    ]
  },
  {
    name: "East Abbotsford",
    crane: 355.0,
    dump: 212.0,
    split: 219.0,
    bounds: [
      {
        lng: -122.2929382,
        lat: 49.1246686
      },
      {
        lng: -122.2428131,
        lat: 49.1012968
      },
      {
        lng: -122.2414398,
        lat: 49.0022944
      },
      {
        lng: -122.1510492,
        lat: 49.0030422
      },
      {
        lng: -122.082936,
        lat: 49.0545315
      },
      {
        lng: -122.0428959,
        lat: 49.078782
      },
      {
        lng: -121.9802461,
        lat: 49.0950746
      },
      {
        lng: -122.0643602,
        lat: 49.14069
      },
      {
        lng: -122.0858179,
        lat: 49.1528171
      },
      {
        lng: -122.2293268,
        lat: 49.1299079
      },
      {
        lng: -122.260655,
        lat: 49.1440589
      },
      {
        lng: -122.2929382,
        lat: 49.1246686
      }
    ]
  },
  {
    name: "Chilliwack",
    crane: 420.0,
    dump: 256.0,
    split: 262.5,
    bounds: [
      {
        lng: -122.0858179,
        lat: 49.1528171
      },
      {
        lng: -121.9805891,
        lat: 49.0947935
      },
      {
        lng: -122.0441232,
        lat: 49.0779561
      },
      {
        lng: -122.0883056,
        lat: 49.0509927
      },
      {
        lng: -122.05781,
        lat: 49.0199329
      },
      {
        lng: -122.0002442,
        lat: 49.0006218
      },
      {
        lng: -121.9278895,
        lat: 49.1056395
      },
      {
        lng: -121.7951529,
        lat: 49.1542196
      },
      {
        lng: -121.7057622,
        lat: 49.2019677
      },
      {
        lng: -121.75005,
        lat: 49.2062296
      },
      {
        lng: -121.9314943,
        lat: 49.2203587
      },
      {
        lng: -122.0655287,
        lat: 49.1508097
      },
      {
        lng: -122.0858179,
        lat: 49.1528171
      }
    ]
  },
  {
    name: "Maple Ridge Zone 2",
    crane: 209.0,
    dump: 116.0,
    split: 124.0,
    bounds: [
      {
        lng: -122.6225708,
        lat: 49.2425672
      },
      {
        lng: -122.6229566,
        lat: 49.2125238
      },
      {
        lng: -122.6018429,
        lat: 49.2089913
      },
      {
        lng: -122.601142,
        lat: 49.2421683
      },
      {
        lng: -122.6225708,
        lat: 49.2425672
      }
    ]
  },
  {
    name: "Pitt Meadows Zone 2",
    crane: 189.0,
    dump: 109.0,
    split: 116.0,
    bounds: [
      {
        lng: -122.7061272,
        lat: 49.2716129
      },
      {
        lng: -122.629781,
        lat: 49.2708289
      },
      {
        lng: -122.5786537,
        lat: 49.3508558
      },
      {
        lng: -122.623629,
        lat: 49.3508558
      },
      {
        lng: -122.6754707,
        lat: 49.3155066
      },
      {
        lng: -122.6861709,
        lat: 49.2899781
      },
      {
        lng: -122.7061272,
        lat: 49.2716129
      }
    ]
  },
  {
    name: "Maple Ridge Zone 4",
    crane: 250.0,
    dump: 131.0,
    split: 138.0,
    bounds: [
      {
        lng: -122.5621976,
        lat: 49.2554571
      },
      {
        lng: -122.5539065,
        lat: 49.2235395
      },
      {
        lng: -122.5535631,
        lat: 49.1775514
      },
      {
        lng: -122.513417,
        lat: 49.1686245
      },
      {
        lng: -122.4698438,
        lat: 49.1702323
      },
      {
        lng: -122.4698438,
        lat: 49.2487342
      },
      {
        lng: -122.5621976,
        lat: 49.2554571
      }
    ]
  },
  {
    name: "Mission Zone 1",
    crane: 325.0,
    dump: 181.0,
    split: 191.0,
    bounds: [
      {
        lng: -122.4045865,
        lat: 49.1969908
      },
      {
        lng: -122.4069865,
        lat: 49.1960782
      },
      {
        lng: -122.405765,
        lat: 49.1965205
      },
      {
        lng: -122.4045865,
        lat: 49.1969908
      }
    ]
  },
  {
    name: "Mission Zone 1",
    crane: 325.0,
    dump: 181.0,
    split: 191.0,
    bounds: [
      {
        lng: -122.4045865,
        lat: 49.1969908
      },
      {
        lng: -122.4069865,
        lat: 49.1960782
      },
      {
        lng: -122.4251827,
        lat: 49.1693729
      },
      {
        lng: -122.3726539,
        lat: 49.1336684
      },
      {
        lng: -122.3128292,
        lat: 49.1228285
      },
      {
        lng: -122.2641628,
        lat: 49.1458535
      },
      {
        lng: -122.2655361,
        lat: 49.1805953
      },
      {
        lng: -122.3510243,
        lat: 49.1794732
      },
      {
        lng: -122.4045865,
        lat: 49.1969908
      }
    ]
  },
  {
    name: "Delta Zone 2",
    crane: 310.0,
    dump: 151.0,
    split: 158.0,
    bounds: [
      {
        lng: -123.0570036,
        lat: 49.0898311
      },
      {
        lng: -123.0569178,
        lat: 49.0901964
      },
      {
        lng: -123.0571753,
        lat: 49.0898315
      },
      {
        lng: -123.0570036,
        lat: 49.0898311
      }
    ]
  },
  {
    name: "Delta Zone 2",
    crane: 310.0,
    dump: 151.0,
    split: 158.0,
    bounds: [
      {
        lng: -123.0569178,
        lat: 49.0901964
      },
      {
        lng: -122.9344366,
        lat: 49.0894942
      },
      {
        lng: -122.8898044,
        lat: 49.0890445
      },
      {
        lng: -122.8942451,
        lat: 49.0932313
      },
      {
        lng: -122.898,
        lat: 49.099104
      },
      {
        lng: -122.9017555,
        lat: 49.1051452
      },
      {
        lng: -122.9058548,
        lat: 49.1109053
      },
      {
        lng: -122.911905,
        lat: 49.1137147
      },
      {
        lng: -122.9214537,
        lat: 49.1156249
      },
      {
        lng: -122.9272267,
        lat: 49.1194446
      },
      {
        lng: -122.9279136,
        lat: 49.1277854
      },
      {
        lng: -122.9287716,
        lat: 49.1339919
      },
      {
        lng: -122.9225931,
        lat: 49.134217
      },
      {
        lng: -122.9195032,
        lat: 49.1624559
      },
      {
        lng: -122.9305753,
        lat: 49.1665256
      },
      {
        lng: -122.9430197,
        lat: 49.158022
      },
      {
        lng: -122.9773523,
        lat: 49.1539804
      },
      {
        lng: -123.0367475,
        lat: 49.147019
      },
      {
        lng: -123.0680296,
        lat: 49.1287119
      },
      {
        lng: -123.0781173,
        lat: 49.1237702
      },
      {
        lng: -123.0675588,
        lat: 49.1155403
      },
      {
        lng: -123.0622808,
        lat: 49.1113126
      },
      {
        lng: -123.0611871,
        lat: 49.1103504
      },
      {
        lng: -123.057776,
        lat: 49.1084892
      },
      {
        lng: -123.0572825,
        lat: 49.105496
      },
      {
        lng: -123.0572503,
        lat: 49.0981553
      },
      {
        lng: -123.0572772,
        lat: 49.0952437
      },
      {
        lng: -123.0569178,
        lat: 49.0901964
      }
    ]
  }
];
